import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import authApiService from "../../services/authServices";
import { Link } from "react-router-dom";
import { ThreeDots } from 'react-loader-spinner';
import './standing.css'


function Standings() {
  const [leaderboard, setLeaderboard] = useState([]);
  const [isLoading, setIsLoading] = useState(true);


  useEffect(() => {
    fetchLeaderboard();

    const handleSeasonChange = () => {
        fetchLeaderboard();  // Re-fetch data when season changes
    };

    window.addEventListener("seasonChange", handleSeasonChange);

    return () => {
        window.removeEventListener("seasonChange", handleSeasonChange);
    };
}, []);



  const fetchLeaderboard = async () => {
    try {
      setIsLoading(true);
      const selectedSeasonId = localStorage.getItem("selectedSeasonId");
      
      // Don't make API call if no seasonId is available
      if (!selectedSeasonId || selectedSeasonId === "0") {
        console.log("No seasonId available, skipping API call");
        setLeaderboard([]);
        setIsLoading(false);
        return;
      }
      
      const response = await authApiService.get("viewLeaderboardPoints", { seasonId: selectedSeasonId});
      if (response.data && response.data) {
        setLeaderboard(response.data);
      } else {
        setLeaderboard([]);
      }
    } catch (error) {
      console.error("Error fetching leaderboard data:", error);
      setLeaderboard([]);
    } finally {
      setIsLoading(false);
    }
  };
  

  const isDataAvailable = leaderboard.length > 0;

    const placeholderRows = Array.from({ length: 16 }, (_, i) => ({
    id: `placeholder-${i + 1}`,
    fullName: "- -",
    homeCourt: "0",
    point: "0",
    totalWins: "0",
    totalLosses: "0"
  }));

  const displayData = isDataAvailable ? leaderboard : placeholderRows;
  

const columns = [
    {
      name: "Pos",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px",
      
    },
    {
      name: "Players",
      selector: (row) =>
        isDataAvailable ? (
          <Link to={`/carter/profile?userId=${row.id}`} className="leader-icon">
            <span>
              <img
                src={`/${row.image?.replace(/^\/?/, '')}`}
                alt="Player"
                style={{
                  width: 30,
                  minWidth: 30,
                  height: 30,
                  borderRadius: "50%",
                  objectFit: "cover",
                  marginRight: 8
                }}
              />
            </span>
            {row.fullName}
          </Link>
        ) : (
          <span>- -</span>
        ),
      sortable: true,
      
    },
    {
      name: "Courts",
      selector: (row) => row.homeCourt,
      sortable: true,
    
    },
    {
      name: "Points",
      selector: (row) => row.point,
      sortable: true,
     
    },
    {
      name: "Wins",
      selector: (row) => row.totalWins,
      sortable: true,
    },
    {
      name: "Losses",
      selector: (row) => row.totalLosses,
      sortable: true,
      
    },
  ];


  const customStyles = {
    table: {
        style: {
            border: "1px solid #ddd",
        },
    },
    headRow: {
        // style: {
        //     backgroundColor: "transparent",
        //     backgroundColor: "#00000000",
        //     color: "#ffffff",
        // },
    },
    rows: {
        style: {
            "&:nth-of-type(odd)": {
                backgroundColor: "#dedfdd", // Red background for odd rows
            },
            "&:nth-of-type(even)": {
                backgroundColor: "#ffffff", // White background for even rows
            },
        },
    },
};


  return (
    <div className="page-container col-12  standing_page">     
    <style>{`
  
    .page-container.standing_page {
  top: -35px;
}
.rdt_Table{
    background-color: transparent !important;
    border: none !important;
}
.rdt_TableHeadRow{
  background-color: transparent !important;
  border: none !important;
}
.rdt_TableHeadRow .rdt_TableCol{
  background-color: transparent !important;
  border: none !important;
}
.rdt_TableCol_Sortable, .rdt_TableHeadRow .rdt_TableCol .rdt_TableCol_Sortable{
  background-color: transparent !important;
  border: none !important;
  color: #fff;
}
.rdt_TableCol_Sortable{
  background-color: transparent !important;
  border: none !important;
  color: #fff;
}
.TQWIv{
  background-color: transparent !important;
  border: none !important;
}
.rdt_Table .rdt_TableHead .rdt_TableCol .TQWIv {
  background-color: transparent !important;
  border: none !important;
}

.loader-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 400px;
}
.rdt_Table {
    margin-top: 17px;
}

.rdt_TableHead {
    position: sticky;
    top: 0;
    background: #40444c;
    z-index: 1;
    margin-bottom: 30px;
}
.leader-tab-info.mb-4 {
    top: 15px;
}
    .rdt_TableCell{
    min-width: 30px !important;
    }
    .gyOqqb{
    display: inherit !important;
    }
.rdt_TableBody .rdt_TableRow:first-child {
    position: sticky;
  top: 0;
    z-index: 1;
    margin-top: 30px;
}
  .rdt_Table {
    max-height: calc(100vh - 266px);
    
}
    .rdt_TableBody {
    overflow-y: auto;
}
`}
    </style> 
      <div className="section">
        <div className="left"></div>
        <div className="right"></div>
      </div>
      {isLoading ? (
        <div className="loader-container">
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#4fa94d"
            ariaLabel="three-dots-loading"
            visible={true}
          />
        </div>
      ) : (
        <div className="leader-tab-info mb-4">          
          <DataTable
            columns={columns}          
            data={displayData}        
            highlightOnHover
            striped
            customStyles={customStyles}
          />
        </div>
      )}
    </div>
  );
}

export default Standings;

